import {
  Action_GetDMAttributes,
  Action_GetDMAttributesSuccess,
} from "actions/DanhMuc/DanhMucAttributes/actionTypes";

const initialState = {
  isSaveOk: false,
  isDeleteOk: false,
  objDataAttributes: {},
};
////////////////////////
const Reducer_GetDMAttributes = (state, action) => ({
  ...state,
  isSaveOk: false,
});
const Reducer_GetDMAttributesSuccess = (state, action) => {
  console.log("check the data in reducer", action);
  return {
    ...state,
    objDataAttributes: action.payload,
  };
};



// end 
const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case Action_GetDMAttributes:
      return Reducer_GetDMAttributes(state, action);
    case Action_GetDMAttributesSuccess:
      return Reducer_GetDMAttributesSuccess(state, action);
    default:
      return state;
  }
};
export default authReducer;
